module.exports = __webpack_public_path__ + "img/dark_mode.c66c7d0d.jpg";